module.exports = __webpack_public_path__ + "/login_ui/img/gq-777b51e5d98fbf1352af6252dbdf3a33.svg";